/**
 * <diagram-pair> — one diagram on the diagram page (sections/diagram-gallery.liquid). Pointing at
 * or focusing a numbered row lights up its dot on the diagram, and the other way round, the same
 * pairing the mega menu does (assets/mega-menu.js): `.is-paired` on every element of the panel
 * whose `data-spot` matches. Recomputed on every pointerover, so moving between the number and
 * the label never flickers. Without JS the rows and dots are plain links that simply stay apart.
 */
class DiagramPair extends HTMLElement {
  connectedCallback() {
    this.pair = (e) => {
      const spot = e.target.closest?.('[data-spot]');
      const key = spot ? spot.dataset.spot : null;
      for (const el of this.querySelectorAll('[data-spot]')) {
        el.classList.toggle('is-paired', el.dataset.spot === key);
      }
    };
    this.clear = () => {
      for (const el of this.querySelectorAll('[data-spot].is-paired')) el.classList.remove('is-paired');
    };
    this.addEventListener('pointerover', this.pair);
    this.addEventListener('focusin', this.pair);
    this.addEventListener('pointerleave', this.clear);
    this.addEventListener('focusout', this.clear);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerover', this.pair);
    this.removeEventListener('focusin', this.pair);
    this.removeEventListener('pointerleave', this.clear);
    this.removeEventListener('focusout', this.clear);
  }
}

if (!customElements.get('diagram-pair')) customElements.define('diagram-pair', DiagramPair);
